import axios from '~/services/axios_auth'

export interface TariffRequestBody {
  sku: number,
  date: string|null
}

export const useTariffService = () => {
  let runtimeConfig
  try {
    runtimeConfig = useRuntimeConfig()
  } catch (_) {
    // useRuntimeConfig not available, must be used out of context
    runtimeConfig = {
      public: process.env
    }
  }

  const baseurl = runtimeConfig.public.BASIC_API_URL  || 'https://apim-enext-stg.azure-api.net'

  const tariff_config_axios = axios.create({
    baseURL: runtimeConfig.public.PURCHASE_API || (baseurl + '/purchase-api/1.0.0')
  })

  const getTariffsBulk = async function(payload: TariffRequestBody[]) {
    const res: any = await tariff_config_axios.post('/tariffs/$bulkRequest', payload).catch(() => {
      return []
    })

    return res?.data ?? []
  }

  return {
    getTariffsBulk
  }
}
